import { SteeringWheel, MapPin, Phone, EnvelopeSimple } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-black">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <SteeringWheel size={28} weight="fill" className="text-primary" />
            <span className="font-display font-black tracking-tighter uppercase text-lg">Ranchi·Digital Seva</span>
          </div>
          <p className="text-muted-foreground max-w-sm text-sm leading-relaxed">
            Your trusted partner for hassle-free driving license services in Ranchi, Jharkhand. We handle the paperwork, you enjoy the drive.
          </p>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-primary mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 shrink-0 text-primary" /> Kutchary, Ranchi 834001</li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-primary" /> +91 62090 00018</li>
            <li className="flex items-center gap-2"><EnvelopeSimple size={16} className="text-primary" /> ranchidigitalseva01@gmail.com</li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-primary mb-4">Hours</h4>
          <ul className="space-y-2 text-sm text-muted-foreground font-mono">
            <li>Mon — Sat</li>
            <li>09:00 — 18:00</li>
            <li className="text-accent">Sunday: Closed</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-6 text-center">
        <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
          © {new Date().getFullYear()} Ranchi Digital Seva — Facilitation services. Not a government body.
        </p>
      </div>
    </footer>
  );
}
